import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { DocumentFolderCardComponent } from './document-folder-card/document-folder-card.component';
import { DocumentCardComponent } from './document-card/document-card.component';
import { DocumentEmptyStateComponent } from './document-empty-state/document-empty-state.component';
import { DocumentSearchComponent } from './document-search/document-search.component';
import { DocumentBreadcrumbComponent } from './document-breadcrumb/document-breadcrumb.component';
import { DocumentListComponent } from './document-list/document-list.component';
import { DocumentViewerComponent } from './document-viewer/document-viewer.component';

const COMPONENTS = [
  DocumentFolderCardComponent,
  DocumentCardComponent,
  DocumentEmptyStateComponent,
  DocumentSearchComponent,
  DocumentBreadcrumbComponent,
  DocumentListComponent,
  DocumentViewerComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule.forChild(),
    ScrollingModule,
  ],
  exports: [...COMPONENTS],
})
export class DocumentsSharedModule {}
